import {
    authorizationServicesPath,
} from "../../Constants";
import axios from "axios";

const restUrl = authorizationServicesPath + '/organizations/organization-user-entity-roles'

export default class OrganizationUserRolesServices {

    static async getAll(id) {
        return axios.get(restUrl + "/" + id + "/by-organization-user-entity");
    }

    static async edit(id, status, roleId) {
        return axios.patch(restUrl + "/" + id + "/by-organization-user-entity" + "?status=" + status + "&roleId=" + roleId, [], {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}